<template>
  <div id="login"  v-wechat-title="this.title">
    <div class="main">
      <ul>
        <li><Input class="li-input" type="text" v-model="username" placeholder="用户名/手机号"  clearable /></li>
        <li><Input class="li-input" type="password" v-model="pwd" placeholder="密码" clearable /></li>
        <li>
          <Button type="primary" @click="async"  style="width: 300px; border-radius: 0">登录</Button>
        </li>
      </ul>
    </div>
    <Modal title="图片验证" v-model="modal" :maskClosable="false"  ref="modal" width="400">
      <div class="ivu-modal-confirm-body" style="padding-left:20px;">
        <Input v-model="code" placeholder="验证码" style="width: 205px; border-radius: 0" />
        <img :src="img" class="code-img" @click="switchImg" />
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="modalCancel">取消</Button>
        <Button type="primary" size="large" @click="login" :loading="modalLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>

export default {
  data() {
    return {
      title:'登录',
      modalLoading: false,
      modal: false,
      username: "",
      pwd: "",
      code: "",
      img: '',
    };
  },
  methods: {
    switchImg() {
      this.img = process.env.VUE_APP_BASE_API+"v1/api/code_img?time="+(new Date()).valueOf()+'&username='+this.username;
    },
    async(){
      if(this.username.length<6){
        this.$warning('用户名不能低于6位');
        return false;
      }
      if(this.pwd.length<6){
        this.$warning('密码不能低于6位');
        return false;
      }
      this.img = process.env.VUE_APP_BASE_API+"v1/api/code_img?time="+(new Date()).valueOf()+'&username='+this.username;
      this.modal = true;
    },
    login(){
      this.modalLoading = true;
      if(this.code.length != 4){
        this.$warning('验证码长度不正确');
        this.modalLoading = false;
        return false;
      }
      let data = {username:this.username,pwd:this.pwd,code:this.code,type:4};
      let obj = this;
      this.$store.dispatch("login",data).then(()=>{
        let token = obj.$store.getters.getToken;
        if( token == ''|| token == undefined ){
          obj.modalLoading = false;
        }else{
          obj.modalLoading = false;
          obj.$success('登录成功');
          if(obj.$store.getters.getTmpUri != undefined){
            this.$store.dispatch('delTmpUri');
            location.href= obj.$store.getters.getTmpUri;
          }else{
            location.href='/';
          }
        }
      })
    },
    modalCancel(){
      this.modalLoading = true;
      this.modal = false;
    }
  },
  mounted(){
    this.$LoadingBar.finish();
  }
};
</script>
<style >
  .main{
    width: 100%;
    overflow: hidden;
    padding: 12% 0;
  }
  .main ul{
    width: 100%;
    overflow: hidden;
  }
  .main li{
    margin: 10px 0;
  }
  .li-input{
      width: 300px;
      border-radius: 0;
  }
  .ivu-input{
      border-radius: 0 !important;
  }
  .code-img{
    width: 90px;
    height:32px;
    margin-left: 5px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    line-height: normal;
  }
</style>
